import { create } from 'zustand';

import { TABS } from '../constants';

type Store = {
  currentTab: TABS;
  setCurrentTab: (tab: TABS) => void;
};

export const useTabsStore = create<Store>((set) => ({
  currentTab: TABS.Position, // Default tab
  setCurrentTab: (tab: TABS) => set({ currentTab: tab }),
}));
